// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
    background-repeat: no-repeat;
    background-size: contain;
    height: 63px;
    width: 125px;
    max-height: 63px;
    max-width: 125px;
    flex-grow: 1;
    filter: drop-shadow(0 5px 5px black);
    background-position: center;
}

.custom-app-bar {
    box-shadow: none;
    top: 15px;
    background-color: transparent;
}

.custom-app-bar__toolbar {
    justify-content: space-between;
}

.custom-app-bar__toolbar__search-container {
    display: flex;
    width: fit-content;
    justify-content: center;
}

.icon-button {
    height: fit-content;
    color: #f7f7f7;
}

.sign-in-button {
    background-color: #f7f7f7;
    color: #000;
}

.sign-in-button:hover {
    background-color: #f7f7f7;
    scale: 1.05;
}

.menu-container {
    margin-top: 45px;
}

.menu-container__list-item {
    padding: 0;
}

.app-bar-icons-container {
    flex-basis: 100px;
    display: flex;
    justify-content: center;
    flex-grow: 0;
    gap: 3rem;
}

.user-popper-container {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.user-settings-menu-header-container {
    padding: 1rem 2rem 0.5rem 0.5rem;
    border-bottom: 1px solid grey;
}

.big-logo {
    max-width: unset;
    max-height: unset;
    height: 202px;
    width: 400px;
    flex-grow: unset;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}

/* \$\$\$\$\$\$\$\$\$\$\$\$ MEDIA QUERY SMALL \$\$\$\$\$\$\$\$\$\$\$\$ */

@media only screen and (max-height: 500px) {
    .big-logo {
        height: 101px;
        width: 241px;
        max-height: 101px;
        max-width: 241px;
    }

    .sign-in-button {
        padding: 3px 1px;
    }
}

@media only screen and (max-width: 1200px) {
    .custom-app-bar__toolbar {
        justify-content: space-between;
    }
}

@media only screen and (max-width: 992px) {
    .custom-app-bar__toolbar {
        min-height: 48px;
    }

    .custom-app-bar__toolbar__search-container {
        width: 100%;
    }
}

@media only screen and (max-width: 700px) {
    .big-logo {
        height: 181px;
        width: 321px;
        max-height: 181px;
        max-width: 321px;
    }

    .custom-app-bar__toolbar {
        min-height: 48px;
    }

    .custom-app-bar__toolbar__search-container {
        width: 100%;
    }

    .sign-in-button {
        padding: 3px 1px;
    }
}

@media only screen and (max-width: 400px) {
    .big-logo {
        height: 131px;
        width: 271px;
        max-height: 131px;
        max-width: 271px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/responsiveAppBar/ResponsiveAppBar.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B;;AAEA,gDAAgD;;AAEhD;IACI;QACI,aAAa;QACb,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;IACpB;AACJ","sourcesContent":[".logo {\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 63px;\n    width: 125px;\n    max-height: 63px;\n    max-width: 125px;\n    flex-grow: 1;\n    filter: drop-shadow(0 5px 5px black);\n    background-position: center;\n}\n\n.custom-app-bar {\n    box-shadow: none;\n    top: 15px;\n    background-color: transparent;\n}\n\n.custom-app-bar__toolbar {\n    justify-content: space-between;\n}\n\n.custom-app-bar__toolbar__search-container {\n    display: flex;\n    width: fit-content;\n    justify-content: center;\n}\n\n.icon-button {\n    height: fit-content;\n    color: #f7f7f7;\n}\n\n.sign-in-button {\n    background-color: #f7f7f7;\n    color: #000;\n}\n\n.sign-in-button:hover {\n    background-color: #f7f7f7;\n    scale: 1.05;\n}\n\n.menu-container {\n    margin-top: 45px;\n}\n\n.menu-container__list-item {\n    padding: 0;\n}\n\n.app-bar-icons-container {\n    flex-basis: 100px;\n    display: flex;\n    justify-content: center;\n    flex-grow: 0;\n    gap: 3rem;\n}\n\n.user-popper-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.user-settings-menu-header-container {\n    padding: 1rem 2rem 0.5rem 0.5rem;\n    border-bottom: 1px solid grey;\n}\n\n.big-logo {\n    max-width: unset;\n    max-height: unset;\n    height: 202px;\n    width: 400px;\n    flex-grow: unset;\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n/* $$$$$$$$$$$$ MEDIA QUERY SMALL $$$$$$$$$$$$ */\n\n@media only screen and (max-height: 500px) {\n    .big-logo {\n        height: 101px;\n        width: 241px;\n        max-height: 101px;\n        max-width: 241px;\n    }\n\n    .sign-in-button {\n        padding: 3px 1px;\n    }\n}\n\n@media only screen and (max-width: 1200px) {\n    .custom-app-bar__toolbar {\n        justify-content: space-between;\n    }\n}\n\n@media only screen and (max-width: 992px) {\n    .custom-app-bar__toolbar {\n        min-height: 48px;\n    }\n\n    .custom-app-bar__toolbar__search-container {\n        width: 100%;\n    }\n}\n\n@media only screen and (max-width: 700px) {\n    .big-logo {\n        height: 181px;\n        width: 321px;\n        max-height: 181px;\n        max-width: 321px;\n    }\n\n    .custom-app-bar__toolbar {\n        min-height: 48px;\n    }\n\n    .custom-app-bar__toolbar__search-container {\n        width: 100%;\n    }\n\n    .sign-in-button {\n        padding: 3px 1px;\n    }\n}\n\n@media only screen and (max-width: 400px) {\n    .big-logo {\n        height: 131px;\n        width: 271px;\n        max-height: 131px;\n        max-width: 271px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
